import { LegacyPhotosUnlinkedFromAssetEvent } from '../event/legacy-photos-unlinked-from-asset.event';
const legacyPhotosUnlinkedFromAssetProjections = {
    [LegacyPhotosUnlinkedFromAssetEvent.name]: (_event, state) => ({
        ...state,
    }),
};
export default legacyPhotosUnlinkedFromAssetProjections;
//# sourceMappingURL=legacy-photos-unlinked-from-asset.projection.js.map